package nl.volleyplanner.web.base.component

import kotlinx.coroutines.flow.StateFlow
import kotlinx.html.TagConsumer
import nl.volleyplanner.web.base.HTMLComponent
import org.w3c.dom.HTMLElement

class StatusMessageComponent(
    val statusMessageFlow: StateFlow<(TagConsumer<HTMLElement>) -> HTMLElement>
) : HTMLComponent() {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return statusMessageFlow.value.invoke(consumer)
    }

    override suspend fun getState() = statusMessageFlow
}